import ApiService from "./api.service";
const SalaryCalculationService = {
    GetSalaryByPINFL(phonenumber,pinfl,Ondate){
        return ApiService.get(`/oylik/api/CalculationForm/GetByPhoneNumber?phonenumber=${phonenumber}&pinfl=${pinfl}&Ondate=${Ondate}`)
    }
}
export default SalaryCalculationService